import { Button } from '@usitsdasdesign/dds-react';
import Text from 'atoms/Text';
import TextArea from 'atoms/TextArea';
import getNotificationMessage from 'helper/notificationMessageCompiler';
import { yupValidator } from 'lib/yup-validator';
import ButtonGroup from 'molecules/ButtonGroup';
import Drawer from 'molecules/Drawer';
import SmallDrawer from 'molecules/SmallDrawer';
import UserProfile from 'molecules/UserProfile';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import InfiniteScroll from 'react-infinite-scroll-component';
import { updateActivityLog } from 'services/resourceActivityLog.service';
import useGlobalToastStore from 'store/globalToastStore';
import { useNotificationStore } from 'store/notificationStore';
import * as yup from 'yup';

const updateSkillsActivityLog = async ({
    activityId, actionStatus, reviewComment = null, resourceId
}) => {
    const Res = await updateActivityLog(activityId, { actionStatus, reviewComment, resourceId });
    if (Res.status) return Res.entity;
    if (Array.isArray(Res.error.response.data.error)) return [0];
    return [];
};
function Notifications({
    show, onClose, pendingAction = [], setDrawer
}) {
    const {
        handleSubmit,
        setValue,
        watch
    } = useForm({
        resolver: yupValidator(
            yup.object().shape({
                SuggestionArea: yup.string().required('Enter your suggestion')
            }),
        ),
        defaultValues: {
            SuggestionArea: 'billable'

        }
    });
    const { setToastData } = useGlobalToastStore();

    const [activeTab, setActiveTab] = useState(2);
    const [showDialog, setShowDialog] = useState('');
    const [newNotify, setNewNotify] = useState([]);
    const [selectedNotification, setSelectedNotification] = useState({});

    const { notifications, totalNotification, fetchNotifications } = useNotificationStore((state) => ({
        notifications: state.notifications,
        totalNotification: state.totalNotification,
        fetchNotifications: state.fetchNotifications
    }));

    const updateLog = async (activityId, resourceId, actionStatus, reviewComment = null) => {
        const Res = await updateSkillsActivityLog({
            activityId, resourceId, actionStatus, reviewComment
        });
        if (Res.length) {
            if (Res[0] === 1) setToastData({ show: true, type: 'success', message: 'Request send successfully!' });
            else setToastData({ show: true, type: 'error', message: 'Already approved' });
        }
        setShowDialog('');
        setSelectedNotification({});
    };
    const onSave = (data) => {
        updateLog(selectedNotification.activityLogId, selectedNotification.createdBy, 'To be revised', data.SuggestionArea);
    };

    const handleNotification = () => {
        setNewNotify(notifications?.filter((item) => !item.read).map((notification) => ({
            sourceType: notification.sourceType,
            userpic: '',
            name: notification?.user?.resource?.name,
            date: moment(notification?.createdAt).format('MM/DD/YYYY'),
            time: moment(notification?.createdAt).format('HH:mm'),
            comment: getNotificationMessage(notification?.notificationDetail?.description, notification?.notificationData),
            notifyData: notification?.notificationData
        })) ?? []);
    };

    useEffect(() => {
        if (show) {
            fetchNotifications({ limit: 20, offset: 0 });
        }
    }, [show]);

    useEffect(() => {
        handleNotification();
    }, [notifications]);

    const updateNotificationList = () => {
        fetchNotifications({ limit: 20, offset: newNotify.length });
    };

    const buttons = [
        {
            label: 'Yes, approve', //
            kind: 'primaryLoud',
            onClick: () => {
                setShowDialog('');
                updateLog(selectedNotification.activityLogId, selectedNotification.createdBy, 'Approved');
            }
        },
        {
            label: 'Suggest edit',
            kind: 'primary',
            onClick: () => {
                setShowDialog('suggest-edit');
            }
        },
        {
            label: 'Cancel',
            kind: 'silent',
            color: 'green',
            onClick: () => { setShowDialog(''); setSelectedNotification({}); }
        }
    ];

    if (!show) return null;

    const CLICKABLE_NOTIFICATIONS = ['createDelegate', 'stockCountAssigned']

    const onClickNotification = (notification) => {
        if (notification.sourceType === 'createDelegate') {
            onClose();
            setDrawer('Delegates');
        }
        if (notification.sourceType === 'stockCountAssigned') {
            notification?.notifyData?.url && window.open(notification?.notifyData?.url, '_blank');
        }
    };

    return (
        <Drawer show={true} title="Activity" onClose={onClose} headerMargin='' bodyClass='overflow-hidden'>
            <SmallDrawer show={showDialog === 'Approve-request'} title='Are you sure you want to approve this request?'
                onClose={() => { setShowDialog(''); }}
                onSave={() => { }}
            >
                <div className='flex flex-start'>
                    <ButtonGroup buttons={buttons} />
                </div>
            </SmallDrawer>
            <SmallDrawer show={showDialog === 'suggest-edit'} title='Suggest Edit'
                onClose={() => { setShowDialog(''); }}
                onSave={handleSubmit(onSave)} //
                isFooter={true}
                cancelLabel='Cancel'
                saveLabel='Send for revision'
                isDisabled={!watch('SuggestionArea').trim()}
                drawerHeight='md:h-[250px]'
            >
                <TextArea
                    label="Your Suggestion"
                    ariaLabel="Label"
                    value={watch('SuggestionArea')}
                    name='SuggestionArea'
                    onValueChange={(val) => setValue('SuggestionArea', val)}
                    minHeight='50'
                />
            </SmallDrawer>
            <div id='notificationDrawer' className="relative w-full h-full overflow-auto">
                <InfiniteScroll dataLength={newNotify.length} next={updateNotificationList} hasMore={newNotify.length < totalNotification} scrollableTarget='notificationDrawer'>
                    <div className='flex flex-col gap-4'>
                        {newNotify?.map((item, i) => (
                            <div
                                key={i}
                                onClick={() => onClickNotification(item)}
                                className="flex items-center py-2 px-3 border justify-between hover:bg-teal-50"
                            >
                                <div className="flex gap-2 items-start relative w-full">
                                    <div className='relative w-10 h-10 flex-none'>
                                        <UserProfile
                                            src={item?.userpic}
                                            name={item?.name}
                                            layout="fill"
                                            objectFit="cover"
                                            fontSize='text-2xl'
                                        />
                                    </div>
                                    <div className="">
                                        <div className="sm:flex mb-1 items-center gap-1">
                                            <Text variant="bodySemibold" className="break-words">
                                                {item.name}  {' '}
                                            </Text>
                                            <span className='sm:block hidden'>|</span>
                                            <Text variant="label">
                                                {item.date} {item.time}
                                            </Text>
                                        </div>
                                        <Text
                                            variant="label"
                                            color="text-gray-1100"
                                            className={`mb-1 ${CLICKABLE_NOTIFICATIONS?.includes(item.sourceType) ? 'cursor-pointer' : ''}`}
                                        >
                                            {item.comment}
                                        </Text>
                                        {
                                            item.sourceType === 'employeeAvailability' && item.notifyData?.publicUrl
                                            && <Button onClick={() => {
                                                window.open(item.notifyData?.publicUrl, '_blank');
                                            }} label="Download Report" size="s" />
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </InfiniteScroll>
            </div>
        </Drawer >
    );
}

export default Notifications;
